import { useNavigate } from "react-router-dom";

import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Spinner,
  Alert,
} from "design-react-kit";

import { useContext, useEffect, useState } from "react";
import UserContext from "../../store/user-context";
import { useSignIn, useSignOut } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";
import secureLocalStorage from "react-secure-storage";

const CopyClientConfigurationModal = ({
  modalOpen,
  modalCloseHandler,
  destinationClientId,
  getClientConfigurations,
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sourceClientId, setSourceClientId] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (modalOpen) {
      setSourceClientId(Number(secureLocalStorage.getItem("sourceClientId")));
      setError(null);
    }
  }, [modalOpen]);

  const copyClientDocumentsRulesHandler = () => {
    if (
      sourceClientId !== null &&
      sourceClientId !== "" &&
      !isNaN(sourceClientId) &&
      typeof sourceClientId === "number"
    ) {
      setIsLoading(true);
      setError(null);
      sendApiRequest(
        `ClientConfiguration/CopyClientDocumentsRules`,
        "POST",
        true,
        { sourceClientId, destinationClientId },
        signIn,
        signOut,
        navigate,
        null,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            getClientConfigurations();
            modalCloseHandler();
          }
        }
      });
    } else {
      setError(["Formato configurazione non valida."]);
    }
  };

  return (
    <Modal isOpen={modalOpen} toggle={modalCloseHandler}>
      <ModalHeader className="text-center"></ModalHeader>
      <ModalBody>
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="ml-auto mr-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        <p className="text-center" htmlFor="import-from_client">
          Vuoi confermare l'importazione della configurazione da:
        </p>
        <p className="text-center blue">
          {secureLocalStorage.getItem("sourceMunicipalityName")}
        </p>
        <p className="text-center blue">
          {secureLocalStorage.getItem("sourceClientName")}
        </p>
        <div className="col-sm-12 mb-4 mt-2 d-flex align-items-center justify-content-around">
          <Button
            color="white"
            className="mr-2"
            onClick={modalCloseHandler}
            id="user-cancel"
          >
            No
          </Button>
          <Button
            style={{
              backgroundColor: "#5EB423",
              color: "#fff",
              padding: "7px 15px",
            }}
            onClick={(e) => copyClientDocumentsRulesHandler()}
          >
            Si
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CopyClientConfigurationModal;
